import React from 'react';
import SAPTransformationPageComponent from '../components/SolutionsPage/SAPTransformationPage';

/**
 * SAPTransformationPage - SAP Transformation page wrapper
 */
export default function SAPTransformationPage() {
  return <SAPTransformationPageComponent />;
}
